import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template42: Segunda página de consejos (Tips2)
// Basado en Tips2.jsx de guia-tokio; todo el contenido viene de page (backend).
// Valores CSS en píxeles para evitar que MUI multiplique por 8.
const Template42 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page.texts?.[0]?.content;
	const tips =
		Array.isArray(page.tips)
			? page.tips
			: Array.isArray(page.data?.tips)
			? page.data.tips
			: Array.isArray(page.data?.data?.tips)
			? page.data.data.tips
			: [];

	const pageOrder =
		page.order !== undefined
			? page.order
			: page.data?.order !== undefined
			? page.data.order
			: -1;
	const isTokioGuide = headerBackgroundColor === "#24221a";
	const actualHeaderColor =
		isTokioGuide && pageOrder > 0 ? "#e24217" : (headerBackgroundColor || "#e24217");
	const cardBorderColor = actualHeaderColor;
	const linkColor = actualHeaderColor;
	const contentColor = textColor || "#444";

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "10px !important",
				},
				"& a": {
					color: linkColor,
					fontWeight: 700,
					textDecoration: "underline",
				},
			}}
		>
			{/* CABECERA */}
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0px",
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: "0px",
						zIndex: 99999,
					}}
				>
					{headerText}
				</Box>
			)}

			{/* CONSEJOS */}
			<Box
				data-block-id="text-1"
				sx={{
					padding: "0px 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					position: "relative",
					marginTop: "20px",
				}}
			>
				{tips.map((tip, index) => (
					<Box
						key={tip.texto ? String(tip.texto).slice(0, 50) : index}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							border: `2px solid ${cardBorderColor}`,
						}}
					>
						{tip.icono && (
							<Box sx={{ fontSize: "18px" }}>{tip.icono}</Box>
						)}
						{tip.texto &&
							(typeof tip.texto !== "string" ||
								(!tip.texto.includes("<") && !tip.texto.includes(">"))) && (
								<Box
									sx={{
										fontSize: "13px",
										color: contentColor,
									}}
								>
									{typeof tip.texto === "string" ? tip.texto : tip.texto}
								</Box>
							)}
						{tip.texto &&
							typeof tip.texto === "string" &&
							(tip.texto.includes("<") || tip.texto.includes(">")) && (
								<Box
									sx={{
										fontSize: "13px",
										color: contentColor,
										"& a": {
											color: linkColor,
											fontWeight: 700,
											textDecoration: "underline",
										},
									}}
									dangerouslySetInnerHTML={{ __html: tip.texto }}
								/>
							)}
					</Box>
				))}
			</Box>
		</Box>
	);
};

Template42.thumbnail = "/images/template-1.png";

export default Template42;
